import React from "react";
import { DisplayProducts } from "../components/DisplayProducts";

export function Home(): JSX.Element {
    return (
        <div>
            <DisplayProducts></DisplayProducts>
        </div>
    );
}

export default Home;
